import * as angularDatetimePicker from '@danielmoncada/angular-datetime-picker';

window['danielmoncada'] = {
    'angular-datetime-picker': angularDatetimePicker
};
export { angularDatetimePicker };